import { useTheme } from '../lib/ThemeContext';
import { useTranslation } from 'react-i18next';
import { Moon, Sun, X } from 'lucide-react';
import { Button } from './ui/button';

const EveningModePrompt = () => {
    const { t } = useTranslation();
    const { showEveningPrompt, handleEveningPromptResponse, dismissEveningPrompt } = useTheme();

    if (!showEveningPrompt) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl p-6 mx-4 max-w-md w-full animate-in fade-in zoom-in duration-300 relative">
                {/* Close button */}
                <button
                    onClick={dismissEveningPrompt}
                    className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
                    data-testid="evening-prompt-close"
                    aria-label="close"
                >
                    <X className="w-5 h-5" />
                </button>

                {/* Icon */}
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
                        <Moon className="w-8 h-8 text-white" />
                    </div>
                </div>

                {/* Title */}
                <h3
                    className="text-xl font-semibold text-center text-slate-900 dark:text-white mb-2"
                    data-testid="evening-prompt-title"
                >
                    {t('evening_prompt.title')}
                </h3>

                {/* Message */}
                <p className="text-slate-600 dark:text-slate-300 text-center mb-6">
                    {t('evening_prompt.body')}
                    <span className="block mt-2 text-sm text-slate-500 dark:text-slate-400">
                        {t('evening_prompt.note')}
                    </span>
                </p>

                {/* Buttons */}
                <div className="flex gap-3">
                    <Button
                        onClick={() => handleEveningPromptResponse(false)}
                        variant="outline"
                        className="flex-1 h-11"
                        data-testid="evening-prompt-stay-light"
                    >
                        <Sun className="w-4 h-4 mr-2" />
                        {t('evening_prompt.stay_light')}
                    </Button>
                    <Button
                        onClick={() => handleEveningPromptResponse(true)}
                        className="flex-1 h-11 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700"
                        data-testid="evening-prompt-go-dark"
                    >
                        <Moon className="w-4 h-4 mr-2" />
                        {t('evening_prompt.go_dark')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default EveningModePrompt;
